/**
 * @generated SignedSource<<315bd2b079556e4afe62642b922d9cec>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fromDate"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "toDate"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
    }, v3 = {
        "kind": "Variable",
        "name": "fromDate",
        "variableName": "fromDate"
    }, v4 = {
        "kind": "Variable",
        "name": "toDate",
        "variableName": "toDate"
    }, v5 = {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
    }, v6 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        },
        (v5 /*: any*/)
    ], v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v10 = [
        {
            "fields": [
                (v3 /*: any*/),
                (v4 /*: any*/)
            ],
            "kind": "ObjectValue",
            "name": "model"
        }
    ], v11 = [
        (v8 /*: any*/)
    ], v12 = {
        "kind": "InlineFragment",
        "selections": (v11 /*: any*/),
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "assignedEntity",
        "plural": false,
        "selections": [
            (v7 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": (v11 /*: any*/),
                "type": "ISchedulableEntity",
                "abstractKey": "__isISchedulableEntity"
            },
            (v12 /*: any*/)
        ],
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignmentTypeId",
        "storageKey": null
    }, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    }, v16 = {
        "alias": null,
        "args": null,
        "concreteType": "AssignmentType",
        "kind": "LinkedField",
        "name": "assignmentType",
        "plural": false,
        "selections": [
            (v15 /*: any*/),
            (v8 /*: any*/)
        ],
        "storageKey": null
    }, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    }, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "end",
        "storageKey": null
    }, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "start",
        "storageKey": null
    }, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    }, v22 = {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v23 = {
        "alias": null,
        "args": (v10 /*: any*/),
        "filters": [
            "where"
        ],
        "handle": "connection",
        "key": "useGetPlannedAbsences_plannedAbsences",
        "kind": "LinkedHandle",
        "name": "plannedAbsences"
    }, v24 = [
        (v19 /*: any*/),
        (v8 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "AbsenceCalendarPageQuery",
            "selections": [
                {
                    "args": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        (v5 /*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "AbsenceCalendarGridQuery"
                },
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AbsenceCalendarFilter_options"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Operation",
            "name": "AbsenceCalendarPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v6 /*: any*/),
                    "concreteType": "SchedulableEntityConnection",
                    "kind": "LinkedField",
                    "name": "schedulableEntities",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SchedulableEntityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v8 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "displayName",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "ISchedulableEntity",
                                            "abstractKey": "__isISchedulableEntity"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "User",
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "firstname",
                                                            "storageKey": null
                                                        },
                                                        (v9 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Avatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "storageId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "queryTransform",
                                                                            "value": "width=68&height=68&mode=crop&scale=both"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "url",
                                                                    "storageKey": "url(queryTransform:\"width=68&height=68&mode=crop&scale=both\")"
                                                                },
                                                                {
                                                                    "alias": "imageUrl",
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "queryTransform",
                                                                            "value": "width=400&height=400&mode=crop&scale=both"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "url",
                                                                    "storageKey": "url(queryTransform:\"width=400&height=400&mode=crop&scale=both\")"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "employeeId",
                                                            "storageKey": null
                                                        },
                                                        (v8 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v10 /*: any*/),
                                                    "concreteType": "PlannedAbsenceConnection",
                                                    "kind": "LinkedField",
                                                    "name": "plannedAbsences",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PlannedAbsenceEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PlannedAbsence",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v13 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "reasonEvent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v19 /*: any*/),
                                                                                (v8 /*: any*/),
                                                                                (v9 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v20 /*: any*/),
                                                                        (v7 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v21 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v22 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v23 /*: any*/)
                                            ],
                                            "type": "SchedulableUser",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Asset",
                                                    "kind": "LinkedField",
                                                    "name": "asset",
                                                    "plural": false,
                                                    "selections": [
                                                        (v19 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v8 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v10 /*: any*/),
                                                    "concreteType": "PlannedAbsenceConnection",
                                                    "kind": "LinkedField",
                                                    "name": "plannedAbsences",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PlannedAbsenceEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PlannedAbsence",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v13 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "reasonEvent",
                                                                            "plural": false,
                                                                            "selections": (v24 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        (v20 /*: any*/),
                                                                        (v7 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v21 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v22 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v23 /*: any*/)
                                            ],
                                            "type": "SchedulableAsset",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isSchedulableEntity"
                                        },
                                        (v12 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v21 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v22 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v6 /*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "AbsenceCalendarGrid_schedulableEntities",
                    "kind": "LinkedHandle",
                    "name": "schedulableEntities"
                },
                {
                    "alias": null,
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "where",
                            "value": {
                                "disabledDate": {
                                    "eq": null
                                }
                            }
                        }
                    ],
                    "concreteType": "AssignmentTypeConnection",
                    "kind": "LinkedField",
                    "name": "assignmentTypes",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "AssignmentTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AssignmentType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        (v15 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "assignmentTypes(where:{\"disabledDate\":{\"eq\":null}})"
                },
                {
                    "alias": null,
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "where",
                            "value": {
                                "isAbsence": {
                                    "eq": true
                                }
                            }
                        }
                    ],
                    "concreteType": "EventConnection",
                    "kind": "LinkedField",
                    "name": "events",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v24 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "events(where:{\"isAbsence\":{\"eq\":true}})"
                }
            ]
        },
        "params": {
            "cacheID": "7e038414d03e155011b1e3710ddabe3b",
            "id": null,
            "metadata": {},
            "name": "AbsenceCalendarPageQuery",
            "operationKind": "query",
            "text": "query AbsenceCalendarPageQuery(\n  $toDate: DateTime!\n  $fromDate: DateTime!\n  $where: SchedulableEntityFilterInput!\n) {\n  ...AbsenceCalendarGridQuery_4aXe39\n  ...AbsenceCalendarFilter_options\n}\n\nfragment AbsenceCalendarFilter_options on Query {\n  assignmentTypes(where: {disabledDate: {eq: null}}) {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n  events(where: {isAbsence: {eq: true}}) {\n    edges {\n      node {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment AbsenceCalendarGridQuery_4aXe39 on Query {\n  schedulableEntities(where: $where, first: 100) {\n    edges {\n      node {\n        __typename\n        ... on ISchedulableEntity {\n          __isISchedulableEntity: __typename\n          id\n          displayName\n        }\n        ... on SchedulableUser {\n          user {\n            ...User\n            employeeId\n            id\n          }\n        }\n        ... on SchedulableAsset {\n          asset {\n            ...Asset\n            id\n          }\n        }\n        ...useGetPlannedAbsences_plannedAbsences_2E76km\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Asset on Asset {\n  name\n  color\n}\n\nfragment User on User {\n  firstname\n  color\n  avatar {\n    id\n    storageId\n    url(queryTransform: \"width=68&height=68&mode=crop&scale=both\")\n    ...UserImageLightBox\n  }\n}\n\nfragment UserImageLightBox on Avatar {\n  imageUrl: url(queryTransform: \"width=400&height=400&mode=crop&scale=both\")\n}\n\nfragment useGetPlannedAbsences_plannedAbsences_2E76km on SchedulableEntity {\n  __isSchedulableEntity: __typename\n  ... on ISchedulableEntity {\n    __isISchedulableEntity: __typename\n    id\n    displayName\n  }\n  ... on SchedulableUser {\n    plannedAbsences(model: {fromDate: $fromDate, toDate: $toDate}) {\n      edges {\n        node {\n          assignedEntity {\n            __typename\n            ... on ISchedulableEntity {\n              __isISchedulableEntity: __typename\n              id\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          assignmentTypeId\n          assignmentType {\n            title\n            id\n          }\n          description\n          end\n          id\n          reasonEvent {\n            name\n            id\n            color\n          }\n          start\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  ... on SchedulableAsset {\n    plannedAbsences(model: {fromDate: $fromDate, toDate: $toDate}) {\n      edges {\n        node {\n          assignedEntity {\n            __typename\n            ... on ISchedulableEntity {\n              __isISchedulableEntity: __typename\n              id\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          assignmentTypeId\n          assignmentType {\n            title\n            id\n          }\n          description\n          end\n          id\n          reasonEvent {\n            name\n            id\n          }\n          start\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "53e23ce17928732d94d30222864867c3";
export default node;
